.dj{color:var(--brand-primary);}